import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PartnersGrid from "@/components/PartnersGrid";
import { useT } from "@/context/LangContext";

export default function PartnersPage() {
  const { t } = useT();
  return (
    <div className="App">
      <Header />
      <main className="pt-28 md:pt-36 pb-20">
        <section className="container-app">
          <div className="max-w-3xl mb-10">
            <div className="inline-block chip bg-lime-500/15 text-navy-900 mb-4">{t("partners_page.badge")}</div>
            <h1 className="font-heading font-extrabold text-5xl md:text-6xl text-navy-900 tracking-tighter leading-[1]" data-testid="partners-page-title">
              {t("partners_page.title")}
            </h1>
            <p className="mt-5 text-lg text-muted-foreground">
              {t("partners_page.subtitle")}
            </p>
          </div>
          <PartnersGrid />
        </section>
      </main>
      <Footer />
    </div>
  );
}
